import { ModalButton } from '../../components/modal/modal-button'

export class PasswordModalButton extends ModalButton {
  mountComponent(): void {
    super.mountComponent()
    this.focus()
  }
}
